// import icons
import {
  FaYoutube,
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaDiscord,
} from "react-icons/fa";
// import images
import IceSwirlImg from "../src/assets/img/about/ice-swirl.png";
import DividerImg from "../src/assets/img/divider.png";
import StrawberrySlushMenuImg from "../src/assets/img/menu/slush-item-strawberry.jpg";
import BlueRaspberrySlushMenuImg from "../src/assets/img/menu/slush-item-blue.jpg";
import MixedSlushMenuImg from "../src/assets/img/menu/slush-item-mixed.jpg";
import StrawberrySlushMountainMenuImg from "../src/assets/img/menu/slush-item-strawberry-swirl.jpg";
import BlueRaspberrySlushMountainMenuImg from "../src/assets/img/menu/slush-item-blue-raspberry-swirl.jpg";
import MixedSlushMountainMenuImg from "../src/assets/img/menu/slush-item-mixed-swirl.jpg";
import SingleSwirlImg from "../src/assets/img/menu/single-swirl.jpg";
import DoubleSwirlImg from "../src/assets/img/menu/double-swirl.jpg";
import WaffleSwirlImg from "../src/assets/img/menu/waffle-swirl.jpg";
import RainbowSwirlImg from "../src/assets/img/menu/rainbow-swirl.jpg";
import TubSwirlImg from "../src/assets/img/menu/tub-swirl.jpg";
import OysterSwirlImg from "../src/assets/img/menu/oyster-swirl.jpg";
import ChocolateSundaeImg from "../src/assets/img/menu/chocolate-sundae.jpg";
import StrawberrySundaeImg from "../src/assets/img/menu/strawberry-sundae.jpg";
import BubblegumSundaeImg from "../src/assets/img/menu/bubblegum-sundae.jpg";
import SwirlBoatImg from "../src/assets/img/menu/swirl-boat.jpg";
import ChefImg from "../src/assets/img/team/chef.png";
import Logo from "../src/assets/img/header/logo.png";
import FooterSwirlImg from "../src/assets/img/footer/footer-swirl.png";

export const navData = [
  { href: "/", name: "home" },
  { href: "/", name: "about" },
  { href: "/", name: "menu" },
  { href: "/", name: "team" },
  { href: "/", name: "testimonials" },
  { href: "/", name: "book a table" },
  { href: "/", name: "contact" },
];

export const socialData = [
  { href: "/", icon: <FaFacebookF className="social-icon" /> },
  { href: "/", icon: <FaInstagram className="social-icon" /> },
];

export const aboutData = {
  title: "who we are",
  subtitle:
    "Welcome to Drifter's Super Whip Ltd, your go-to destination for delightful soft ice creams and refreshing slush. As a family-run business committed to excellence, we pride ourselves on crafting moments of joy with every swirl. Our sustainable approach, coupled with our dedication to quality and service, ensures that every visit leaves you smiling. Join us in indulging in the magic of our treats and experience the sweetness of Drifter's Super Whip Ltd.",
  btnText: "find out more",
  image: IceSwirlImg,
};

export const menuData = {
  title: "Indulge in Delightful Sensations",
  subtitle: "Satisfy your cravings with our decadent creations",
  dividerImg: DividerImg,
  iceCreamMenuItems: [
    {
      image: SingleSwirlImg,
      name: "Single Cone",
      description: "Classic single scoop cone",
    },
    {
      image: DoubleSwirlImg,
      name: "Double Cone",
      description: "Double the delight with two scoops",
    },
    {
      image: WaffleSwirlImg,
      name: "Waffle Cone",
      description: "Crispy waffle cone perfection",
    },
    {
      image: RainbowSwirlImg,
      name: "Rainbow Cone",
      description: "A colorful twist on classic cones",
    },
    {
      image: TubSwirlImg,
      name: "Tub",
      description: "A tub of creamy indulgence",
    },
    {
      image: OysterSwirlImg,
      name: "Oyster",
      description: "An elegant serving in an oyster shell",
    },
    {
      image: ChocolateSundaeImg,
      name: "Chocolate Knickerbocker Glory",
      description: "Decadent chocolate bliss in a glass",
    },
    {
      image: StrawberrySundaeImg,
      name: "Strawberry Knickerbocker Glory",
      description: "Sweet strawberry delight in a glass",
    },
    {
      image: BubblegumSundaeImg,
      name: "Bubblegum Knickerbocker Glory",
      description: "A burst of bubblegum flavor in a glass",
    },
    {
      image: SwirlBoatImg,
      name: "Boat Sundae",
      description: "A swirl duo, sprinkled with toppings and sauce",
    },
  ],
  slushMenuItems: [
    {
      image: StrawberrySlushMenuImg,
      name: "Strawberry Slush",
      description: "Refreshing strawberry flavor",
    },
    {
      image: BlueRaspberrySlushMenuImg,
      name: "Blue Raspberry Slush",
      description: "Tangy blue raspberry delight",
    },
    {
      image: MixedSlushMenuImg,
      name: "Mixed Slush",
      description: "A delightful blend of flavors",
    },
    {
      image: StrawberrySlushMountainMenuImg,
      name: "Strawberry Slush Mountain",
      description: "A mountain of strawberry goodness",
    },
    {
      image: BlueRaspberrySlushMountainMenuImg,
      name: "Blue Raspberry Slush Mountain",
      description: "Conquer the peak of raspberry flavor",
    },
    {
      image: MixedSlushMountainMenuImg,
      name: "Mixed Slush Mountain",
      description: "A towering mix of fruity bliss",
    },
  ],
};

export const teamData = {
  title: "meet us",
  sub1: " My name is Raja and I represent Drifter’s Super Whip Ltd, we are a 5-star rated and registered family run ice cream company. We take pride in our commitment to excellence, ensuring that we are fully insured with up-to-date £10 million public liability and Level 2 food hygiene certificate",
  sub2: "",
  name: "Raja Khan",
  occupation: "Drifter's Super Whippy ltd.",
  chefImg: ChefImg,
};

export const objectiveData = {
  title: "our sweet mission",
  subtitle: "bringing joyful taste to your streets",
  dividerImg: DividerImg,
  objective: "To deliver pure indulgence, more than one swirl at a time",
  message:
    "In a bustling world, where noise and pollution often drown out the sweetness of life, our mission is simple: to deliver boundless joy directly to your doorstep, all while prioritizing the well-being of our planet. With meticulous attention to detail, we craft each indulgent treat using only the finest ingredients, ensuring that every flavor is a moment of pure delight. As we continue to grow, our commitment to sustainability remains unwavering. By embracing Electric Motor Drive (EMD) technology, we not only reduce noise and emissions but also reaffirm our dedication to nurturing the Earth that sustains us. Just as we savor the sweetness of our desserts, we cherish the opportunity to care for our planet with every step we take",
};

export const reservationData = {
  title: "Contact Details",
  contactReservation: "Call (800) 123-4567 from (5AM - 11PM) daily",
  onlineReservation: "Book online with OpenTable",
  partyReservation: "Note: Reservations required for parties of 6 or more",
  dividerImg: DividerImg,
  availability: `We are readily available to address any inquiries you may have`,
  contactNumber: "07806208493",
  contactEmail: "drifterssuperwhippy@gmail.com",
  endingMessage:
    "Thank you for considering Drifter’s Super Whip Ltd for your upcoming events",
  endingExpectation:
    "We look forward to the possibility of collaborating and contributing to the success of your gatherings",
};

export const newsletterData = {
  title: "join our newsletter",
  subtitle: "Get latest news & updates in your inbox",
  placeholder: "Subscribe our delicious dishes",
  btnText: "subscribe now",
};

export const footerData = {
  swirlImg: FooterSwirlImg,
  dividerImg: DividerImg,
  message: {
    regards: "Regards",
    info: "We hope to hear from you soon",
  },
  contact: {
    title: "contact info",
    phone: "07806208493",
  },
  hours: {
    title: "working hours",
    program: [
      {
        days: "Monday - Sunday",
        hours: "05:00 AM - 11:00 PM",
      },
    ],
  },
  social: {
    title: "social network",
    icons: [
      { href: "/", icon: <FaYoutube /> },
      { href: "/", icon: <FaFacebookF /> },
      { href: "/", icon: <FaInstagram /> },
      { href: "/", icon: <FaPinterestP /> },
      { href: "/", icon: <FaDiscord /> },
    ],
  },
  menuGallery: {
    title: "menu gallery",
    info: "coming soon...",
  },
  content: {
    title: "Drifter's Super Whip Ltd",
    salut: "Serving happiness, on every visit",
    policy: {
      health: {
        title: "Health Policy",
        content:
          "At Drifter's Super Whip Ltd, we prioritize your well-being. Our products are crafted with care and adhere to strict hygiene standards to ensure your safety and satisfaction",
      },
    },
  },
};

export const logos = {
  default: Logo,
};
